import { createInterFont } from '@tamagui/font-inter';
import { defaultConfig } from '@tamagui/config/v4';
import { createMedia } from '@tamagui/react-native-media-driver';
import { shorthands } from '@tamagui/shorthands';
import { tokens } from '@tamagui/themes/v3';
// import { light, dark } from '@tamagui/themes'
import { createTamagui } from 'tamagui';
import { animations } from './animations';

const gilroyFace = {
  normal: { normal: 'Gilroy-Regular', italic: 'GilroyItalic' },
  bold: { normal: 'Gilroy-Bold', italic: 'GilroyBoldItalic' },
  100: { normal: 'Gilroy-Thin', italic: 'Gilroy-ThinItalic' },
  200: { normal: 'Gilroy-UltraLight', italic: 'Gilroy-UltraLightItalic' },
  300: { normal: 'Gilroy-Light', italic: 'Gilroy-LightItalic' },
  400: { normal: 'Gilroy-Regular', italic: 'Gilroy-Italic' },
  500: { normal: 'Gilroy-Medium', italic: 'Gilroy-MediumItalic' },
  600: { normal: 'Gilroy-SemiBold', italic: 'Gilroy-SemiBoldItalic' },
  700: { normal: 'Gilroy-Bold', italic: 'Gilroy-BoldItalic' },
  800: { normal: 'Gilroy-ExtraBold', italic: 'Gilroy-ExtraBoldItalic' },
  900: { normal: 'Gilroy-Black', italic: 'Gilroy-BlackItalic' },
};

const headingFont = createInterFont({
  family: 'Gilroy',
  size: {
    6: 15,
  },
  transform: {
    6: 'uppercase',
    7: 'none',
  },
  weight: {
    6: '400',
    7: '700',
  },
  color: {
    6: '$colorFocus',
    7: '$color',
  },
  letterSpacing: {
    0: 0,
    4: 0,
    5: 2,
    6: 1,
    7: 2,
    8: -1,
    9: -2,
    10: 0,
    12: -4,
    14: -5,
    15: -6,
  },
  face: gilroyFace,
});

const bodyFont = createInterFont({
  family: 'Gilroy',
  face: gilroyFace,
  size: {
    1: 11,
    2: 12,
    3: 13,
    4: 14,
    5: 16,
    6: 18,
    7: 20,
    8: 23,
    9: 30,
    10: 32,
    12: 40,
    14: 48,
  },
});

const gilroyFont = createInterFont({
  family: 'Gilroy',
  face: gilroyFace,
  size: {
    1: 11,
    2: 12,
    3: 13,
    4: 14,
    5: 16,
    6: 18,
    7: 20,
    8: 23,
    9: 30,
    10: 32,
    12: 40,
    14: 48,
  },
});

// v2Config.fonts.body = bodyFont;
// v2Config.fonts.heading = headingFont;
// v2Config.fonts['gilroy'] = gilroyFont;
// v2Config.defaultFont = 'body';
// v2Config.animations = animations;

export const config = createTamagui({
  ...defaultConfig,
  defaultFont: 'body',
  animations,
  shouldAddPrefersColorThemes: true,
  themeClassNameOnRoot: true,
  shorthands,
  fonts: {
    body: bodyFont,
    heading: headingFont,
    gilroy: gilroyFont,
  },
  settings: {
    allowedStyleValues: 'somewhat-strict',
  },
  tokens: {
    ...defaultConfig.tokens,
    size: {
      ...defaultConfig.tokens.size,
      '100vh': '100vh',
      '100dvh': '100dvh',
      '100dvw': '100dvw',
      '100vw': '100vw',
    },
  },

  themes: {
    // ...themes,
    ...defaultConfig.themes,
    dark: {
      background: '#18191A',
      color: '#fff',
      colorHover: '#A7ABAF',
      colorPress: '#fff',
      colorFocus: '#A7ABAF',
      color1: '#fff',
      color2: '#A7ABAF',
      color3: '#8A8A8A',
      color4: '#B3B3B3',
      color5: '#CECECE',
      color6: '#E4E4E4',
      color7: '#F3F4F6',
      color8: '#F9F9F9',
      color9: '#FFFFFF',
      color10: '#FFFFFF',
      color11: '#FFFFFF',
      color12: '#FFFFFF',
      blue10: '#368665',
      green10: '#368665',
      cardbackground: '#242526',
      primary: '#368665',
      overlaybg: '#FFF',
      light: '#FFF',
      grey: '#B3B3B3',
      inputBg: '#3A3B3C',
      darkGrey: '#8A8A8A',
      bodyBackground: '#0F0F0F',
      profileLightGreen: '#222',
      darkLight: '#FFF',
      expectAnswerCardBg: '#e7fbf3',
      linearGradientColor1: '#222',
      linearGradientColor2: '#17161652',
      textDark: '#FFF',
      lightGrey: '#CECECE',
      viewsCountColor: '#FFF',
      ctaBgColor: '#E8FBF2',
      ctaBorderColor: '#E8FBF2',
      commentSectionTextColor: '#A7ABAF',
      searchBgColor: '#3A3B3C',
      tipsAnswerCardBg: '#E8FBF2',
      disabledButtonColor: '#505151',
      disabledButtonTextColor: '#858586',
      lineHighlight: '#3A3B3C',
      expertNameColor: '#1D130A',
      qnaAnswerTextColor: '#18191A',
      inActiveTab: 'transparent',
      profileTabBorderColor: '#B3B3B3',
      navTabunstokeColor: '#A7ABAF',
      navTabStokeColor: '#368665',
      profileNavTabColor: '#A7ABAF',
      qnaNavTabColor: '#A7ABAF',
      editProfileBorderColor: '#A7ABAF',
      avatarBorder: '#242526',
      profileActiveTab: '#A7ABAF',
      placeholderColor: '#212121',
      placeholderColorBg: '#E4E4E4',
      qnaTooTipColorBg: '#242526',
      qnaToolTipColorText: '#E4E6EA',
      feedBorderLineColor: '#CECECE',
      profileActiveTabBorderColor: '#A7ABAF',
      cropCategoryBg: '#3A3B3C',
      cropBorderColor: '#E4E4E4',
      weatherTextColor: '#A7ABAF',
      darkWeather: '#000000',
      weatherShareIconColor: '#FFF',
      discoverPlaceHolderBg: '#000000',
      danger: '#FF0000',
      seekBarColor: '#368665',
      cardShadowColor: '#000000',
      CardSeperatorColor: '#171717cc',
      profileTabColor: '#000000',
      qnaExperAnswerBannerBgColor: '#E8FBF2',
      commentSectionBackgroundColor: '#F3F4F6',
      multiUploadBackgroundColor: '#18191A',
      qnaCarouselColor: '#393939',
      qnaCarouselQuestionMark: '#393939',
      qnaMAxCharacter: '#D11A2A',
      globalSearchCardBorderColor: '#CAE9DD',
      instructorProfileBg: '#E9F7FF',
      productBannerBtnBcColor: '#FFA927',
      btnBgColor: '#368665',
      myCartDiscountPriceColor: '#D11A2A',
      paymentFailureText: '#E3594F',
      SidebarBgColor: '#F5F5F5',
      qnaBgColor: '#E9E9E9',
      homeFloatingButtonBg: '#1A593F',
      qnaFloatingButtonBg: '#368665',
      separatorColor: '#3A3A3A',
      qnaLanguageDropDownBorderClr: '#BCBCBC',
      productImageBg: '#242526',
      sidebarbackground: '#0E1A4FA6',
      sidebarItemBackground: '#FFFFFF08',
      sidebarLogoutIcon: '#FFFFFF8F',
      filterDropDownArrowColor: '#0E1A4F',
      insightsExpendableTextColor: '#747474',
      insightsExpendableTextCountColor: '#0E1A4F',
      insightsSearchbarPlaceHolderColor: '#0E1A4F66',
      insightsInputBacgroundColor: '#FFFFFF9C',
      insightsBackgroundColor: '#D6EBFD',
      insightsWebFilterBackgroundColor: '#FFFFFF75',
      insightsNumberOfDaysFilterDropDown: '#D9D9D9',
      liveViewbg: '#E4E4E4',
      liveTextbg: '#E5330C',
      chatItembg: '#F3F4F6',
      liveChatInput: '#BCBCBC',
      videoPlayerColor: '#D9D9D9',
      insightsSeperatorColor: '#CFD0DC70',
      lightwhitebg54: 'ffffff54',
      hoverBgColor: '#3a4162',
      darkCharcoal: '#333333',
      flashWhite: '#f0f0f06b',
      mapBorderColor: '#DADEEB',
      starRatingColor: '#FFAE35',
      homeStatusBarColor: '#000000',
      tabBarColor: '#000000',
      displayName: 'dark',
      detailBgColor: '#D3D3D3',
      bronzeText: '#A1824A',
      dark: '#000',
      backgroundcolor: '#fff',
      gray10: 'grey',
      gray11: 'grey',
      gray: 'grey',
      outlineColor: '',
      usertextColor: '#FFF',
      backgroundHover: '#333333',
      cardColor: '#333333',
      qnaXColor: '#fff',
      usertextColorGrey: '',
      usertextColorLight: '',
      devotionalModeratorlabelColor: '#f2f2f2ff',
      sideBarHoverColor: '#333333',
      layoutBorderColor: '#e6e6e6',
      borderColor: '#E4E4E4',
    },
    light: {
      color: '#1D130A',
      colorHover: '#393939',
      colorPress: '#1D130A',
      colorFocus: '#393939',
      color1: '#1D130A',
      color2: '#393939',
      color3: '#8A8A8A',
      color4: '#B3B3B3',
      color5: '#CECECE',
      color6: '#E4E4E4',
      color7: '#F3F4F6',
      color8: '#F9F9F9',
      color9: '#FFFFFF',
      color10: '#FFFFFF',
      color11: '#FFFFFF',
      color12: '#FFFFFF',
      blue10: '#368665',
      green10: '#368665',
      background: '#FDFFFC',
      cardbackground: '#FFFFFF',
      primary: '#368665',
      overlaybg: '#000000',
      light: '#FFF',
      grey: '#B3B3B3',
      inputBg: '#F9F9F9',
      darkGrey: '#393939',
      bodyBackground: '#1D130A',
      profileLightGreen: '#eef4f1',
      darkLight: '#000',
      expectAnswerCardBg: '#e7fbf3',
      linearGradientColor1: '#222',
      linearGradientColor2: '#17161652',
      textDark: '#000000',
      lightGrey: '#CECECE',
      viewsCountColor: '#FFF',
      ctaBgColor: '#FFF',
      ctaBorderColor: '#368665',
      commentSectionTextColor: '#1D130A',
      searchBgColor: '#FFF',
      tipsAnswerCardBg: '#e7fbf3',
      disabledButtonColor: '#CCCCCC',
      disabledButtonTextColor: '#FFF',
      lineHighlight: '#368665',
      expertNameColor: '#000000',
      qnaAnswerTextColor: '#FFF',
      inActiveTab: 'transparent',
      profileTabBorderColor: '#FFF',
      navTabunstokeColor: '#1D130A',
      navTabStokeColor: '#368665',
      profileNavTabColor: '#222222',
      qnaNavTabColor: '#393939',
      editProfileBorderColor: '#368665',
      avatarBorder: '#EEE',
      profileActiveTab: '#454545',
      placeholderColor: '#A7ABAF',
      placeholderColorBg: '#F3F4F6',
      qnaTooTipColorBg: '#e7fbf3',
      qnaToolTipColorText: '#368665',
      feedBorderLineColor: '#CECECE',
      profileActiveTabBorderColor: '#A7ABAF',
      cropCategoryBg: '#F3F4F6',
      cropBorderColor: '#E4E4E4',
      weatherTextColor: '#000000',
      darkWeather: '#000000',
      weatherShareIconColor: '#FFF',
      discoverPlaceHolderBg: '#FFF',
      danger: '#FF0000',
      seekBarColor: '#368665',
      cardShadowColor: '#000000',
      CardSeperatorColor: '#23587A14',
      profileTabColor: '#23587A14',
      qnaExperAnswerBannerBgColor: '#E8FBF2',
      commentSectionBackgroundColor: '#F3F4F6',
      multiUploadBackgroundColor: '#F9F9F9',
      qnaCarouselColor: '#000000',
      qnaCarouselQuestionMark: '#FFFFFF',
      qnaMAxCharacter: '#D11A2A',
      globalSearchCardBorderColor: '#CAE9DD',
      instructorProfileBg: '#E9F7FF',
      productBannerBtnBcColor: '#FFA927',
      btnBgColor: '#FFFF',
      myCartDiscountPriceColor: '#D11A2A',
      paymentFailureText: '#E3594F',
      SidebarBgColor: '#F5F5F5',
      qnaXColor: '#000000',
      qnaBgColor: '#E9E9E9',
      homeFloatingButtonBg: '#1A593F',
      qnaFloatingButtonBg: '#368665',
      separatorColor: '#23587A14',
      qnaLanguageDropDownBorderClr: '#BCBCBC',
      sidebarbackground: '#0E1A4FA6',
      sidebarItemBackground: '#FFFFFF08',
      sidebarLogoutIcon: '#FFFFFF8F',
      filterDropDownArrowColor: '#0E1A4F',
      insightsExpendableTextColor: '#747474',
      insightsExpendableTextCountColor: '#0E1A4F',
      insightsSearchbarPlaceHolderColor: '#0E1A4F66',
      insightsInputBacgroundColor: '#FFFFFF9C',
      insightsBackgroundColor: '#D6EBFD',
      insightsWebFilterBackgroundColor: '#FFFFFF75',
      insightsNumberOfDaysFilterDropDown: '#D9D9D9',
      productImageBg: '#ededed',
      liveViewbg: '#E4E4E4',
      liveTextbg: '#E5330C',
      chatItembg: '#F3F4F6',
      liveChatInput: '#BCBCBC',
      videoPlayerColor: '#D9D9D9',
      insightsSeperatorColor: '#CFD0DC70',
      lightwhitebg54: 'ffffff54',
      hoverBgColor: '#3a4162',
      darkCharcoal: '#333333',
      flashWhite: '#f0f0f06b',
      mapBorderColor: '#DADEEB',
      starRatingColor: '#FFAE35',
      homeStatusBarColor: '#F7E6DB',
      tabBarColor: '#000000',
      displayName: 'light',
      detailBgColor: '#696969',
      bronzeText: '#A1824A',
      dark: '#000',
      backgroundcolor: '#fff',
      gray10: 'grey',
      gray11: 'grey',
      gray: 'grey',
      outlineColor: '',
      usertextColor: '#000',
      backgroundHover: '#f0f0f06b',
      cardColor: '#FDFFFC',
      usertextColorGrey: '',
      usertextColorLight: '',
      devotionalModeratorlabelColor: '#f2f2f2ff',
      sideBarHoverColor: '#f5f8fa',
      layoutBorderColor: '#e6e6e6',
      borderColor: '#E4E4E4',
    },
  },
  media: createMedia({
    xs: { maxWidth: 660 },
    sm: { maxWidth: 800 },
    md: { maxWidth: 1020 },
    lg: { maxWidth: 1280 },
    xl: { maxWidth: 1420 },
    xxl: { maxWidth: 1600 },
    gtXs: { minWidth: 660 + 1 },
    gtSm: { minWidth: 800 + 1 },
    gtMd: { minWidth: 1020 + 1 },
    gtLg: { minWidth: 1280 + 1 },
    short: { maxHeight: 820 },
    tall: { minHeight: 820 },
    hoverNone: { hover: 'none' },
    pointerCoarse: { pointer: 'coarse' },
  }),
});

tokens.color['ncBorderTopColor'] = '#c5c5c5';

// for the compiler to find it
export default config;
